import React, { ChangeEvent } from "react"
import { MenuItem, TextField } from "@mui/material"

import Price from "components/Price"

import { netToGross } from "@secureo/common/utils/tax"

import { ProductConfigurationsBySku } from "@secureo/common/reducers/productDetailPageReducer"
import {
	ConfigurationGroup as ConfigurationGroupInterface,
	ConfigurationGroupProductsBySku,
} from "@secureo/common/typings/Product"
import { CountryCode } from "@secureo/common/typings/CountryCode"

const ConfigurationGroupDropDown = ({
	isLoading,
	countryCode,
	taxRate,
	configurationGroup,
	configurationGroupProductsBySku,
	selectedConfigurationsBySku,
	setSingleConfigurationGroupConfiguration,
}: Props) => {
	const { name: configurationGroupName, items } = configurationGroup

	const value = Object.values(selectedConfigurationsBySku)?.[0]?.sku ?? items?.[0]?.sku

	const changeConfiguration = (event: ChangeEvent<HTMLInputElement>) => {
		const sku = event.target.value

		setSingleConfigurationGroupConfiguration(
			configurationGroupProductsBySku,
			configurationGroupName,
			sku,
		)
	}

	// Prevent uncontrolled drop down
	const configurationProducts = items.filter(
		(item) => configurationGroupProductsBySku?.[item.sku],
	)
	if (configurationProducts.length === 0) return null

	return (
		<div>
			<TextField
				id={configurationGroupName}
				label={configurationGroupName}
				value={value}
				onChange={changeConfiguration}
				margin="normal"
				variant="filled"
				select
				fullWidth
				disabled={isLoading}
			>
				{items.map((item) => {
					const { sku } = item
					const configurationProduct = configurationGroupProductsBySku?.[sku]
					if (!configurationProduct) return null

					const { name, pricesByCountryCode } = configurationProduct

					const netPriceCents = pricesByCountryCode?.[countryCode] ?? 0
					const grossPriceCents = Math.round(netToGross(netPriceCents, taxRate))

					return (
						<MenuItem value={sku} key={sku}>
							<span style={{ marginRight: 3 }}>{name}</span>
							(+
							<Price priceInEuroCents={grossPriceCents} />)
						</MenuItem>
					)
				})}
			</TextField>
		</div>
	)
}

interface Props {
	isLoading: boolean
	countryCode: CountryCode
	taxRate: number
	configurationGroup: ConfigurationGroupInterface
	configurationGroupProductsBySku: ConfigurationGroupProductsBySku
	selectedConfigurationsBySku: ProductConfigurationsBySku
	setSingleConfigurationGroupConfiguration: (
		configurationGroupProductsBySku: ConfigurationGroupProductsBySku,
		configurationGroupName: string,
		sku: string,
	) => void
}

export default ConfigurationGroupDropDown
